import type { Icon16Done } from '@vkontakte/icons';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';

import type { WidgetLocale } from '../../../../../types/widgetLocale';
import { getCountryDisplayName } from '../../../../../utils';

import type { Country } from '../../../model';
import { COUNTRIES } from '../../constants';

import styles from '../../../styles.module.css';

interface Props {
  locale: WidgetLocale;
  selectedCountry: Country;
  handleCountryChange: (code: string) => void;
  getClassName: string | ((country: Country) => string);
  SelectedIcon: typeof Icon16Done;
}

export const renderCountryList = ({
  locale,
  selectedCountry,
  handleCountryChange,
  getClassName,
  SelectedIcon,
}: Props) => {
  return COUNTRIES.map((country) => {
    const className = typeof getClassName === 'function' ? getClassName(country) : getClassName;
    const label = getCountryDisplayName(country.code, locale);
    return (
      <div key={country.code} className={className} onClick={() => handleCountryChange(country.code)}>
        <span>
          {label} <span className={styles.dialCode}>({country.dialCode})</span>
        </span>
        {selectedCountry.code === country.code && <SelectedIcon fill={baseTheme.colorIconAccent.normal} />}
      </div>
    );
  });
};
